import React, {useContext} from "react";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";


const JobCharge = (props) => {//shows estimate charges details .
    let Record = useContext(RecordsManagementContext)
    let Charge = props.Charge
    let charge_value = Charge.Value
    if(props.Charge.Name == 'GRAND TOTAL' && Record.NewTotalCost.toString() != ''){
        return (
            <div className='row mt-2'>
                <div className='col d-flex align-items-center justify-content-center'>{Charge.Name}</div>
                <div className='col'>
                    <div className="input-group-prepend">
                        <div className="input-group">
                            <div className="input-group-text">{Charge.Currency}</div>
                            {Record.NewTotalCost.toString() != '' ? <input className="form-control w-75" defaultValue={Record.NewTotalCost.toString()} disabled/>
                                : <input className="form-control w-75" defaultValue={charge_value} disabled/> }
                        </div>
                    </div>
                </div>
            </div>
        )
    }else if(props.Charge.Name == 'BALANCE DUE' && Record.NewBalanceDue.toString() != ''){
        return (
            <div className='row mt-2'>
                <div className='col d-flex align-items-center justify-content-center'>{Charge.Name}</div>
                <div className='col'>
                    <div className="input-group-prepend">
                        <div className="input-group">
                            <div className="input-group-text">{Charge.Currency}</div>
                            {Record.NewBalanceDue.toString() != '' ? <input className="form-control w-75" defaultValue={Record.NewBalanceDue.toString()} disabled/>
                                : <input className="form-control w-75" defaultValue={charge_value} disabled/> }
                        </div>
                    </div>
                </div>
            </div>
        )
    } else if((Charge.Show) || ((Charge.Name == 'TIP') && Record.TipValue != '')) {
        return (
            <div className='row mt-2'>
                <div
                    className='col d-flex align-items-center justify-content-center'>{Charge.Name}</div>
                <div className='col'>
                    <div className="input-group">
                        { Charge.Name == 'TIP' && Record.TipValue != '' ? <div className="input-group-prepend">
                                {Record.TipValue.toString().includes('%') ? '' : <div className="input-group-text">{Charge.Currency}</div>}
                            </div>  :
                            <div className="input-group-prepend">
                                {charge_value.toString().includes('%') ? '' : <div className="input-group-text">{Charge.Currency}</div>}
                            </div> }
                        {(Charge.Name == 'TIP' && Record.TipValue != '') ? <input className="form-control w-75" defaultValue={Record.TipValue.toString().includes('%') ? Record.TipValue : parseFloat(Record.TipValue).toFixed(2)} disabled/> :
                            <input className="form-control w-75" defaultValue={charge_value} disabled/>
                        }
                    </div>
                </div>
            </div>
        )
    } else {
        return (<></>)
    }
}


const JobChargeWithExtraColumn = (props) => {
    let Charge = props.Charge
    if (Charge.Show) {
        return (
            <div className='row mt-2'>
                <div className='col d-flex align-items-center justify-content-center'>
                    <input className="form-control w-25 form-control-sm"
                           defaultValue={Charge.Value} disabled/>
                    {Charge.Name}
                </div>
                <div className='col'>
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <div
                                className="input-group-text">{Charge.Currency}</div>
                        </div>
                        <input className="form-control w-75"
                               defaultValue={Charge.ExtraValue} disabled/>
                    </div>
                </div>
            </div>
        )
    } else {
        return (<></>)
    }
}

const JobChargeForEstimateAdditionalCharges = (props) => {
    let Charge = props.Charge
    return (
        <>
            {Charge.map((additional_charge, key) => {
                return (<JobCharge key={key} Charge={additional_charge}/>)
            })}
        </>
    )

}

export {JobCharge, JobChargeWithExtraColumn, JobChargeForEstimateAdditionalCharges}